import { Outlet } from 'react-router-dom';
import './LandingPage.css';
import { useRef } from "react";
import Navbar from '@/components/Navbar/Navbar';
import Home from '@/components/Home/Home';
import Info from '@/pages/LandingPage/Info/Info.tsx'
import Pricing from '@/pages/LandingPage/Pricing';
import Testimonials from '@/components/Testimonials/Testimonials';
import Form from '@/components/Form/Form';
import Footer from '@/components/Footer/Footer';


function LandingPage() {
    const homeRef = useRef<HTMLElement>(null);
    const infoRef = useRef<HTMLDivElement>(null);
    const pricingRef = useRef<HTMLDivElement>(null);
    const contactRef = useRef<HTMLDivElement>(null);

    const scrollToSection = (_id: string) => {
      const sectionRef = { home: homeRef, info: infoRef, pricing: pricingRef, contact: contactRef }[_id];
      if (sectionRef?.current) {
        const top = sectionRef.current.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top, behavior: 'smooth' });
      } else {
        const el = document.getElementById(_id);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    };


  return (
    <div className="LandingPage">
      <Navbar scrollToSection={scrollToSection} />

      <Home ref={homeRef} scrollToSection={scrollToSection} />
      <Info ref={infoRef} scrollToSection={scrollToSection} />
      <Pricing ref={pricingRef} scrollToSection={scrollToSection} />
      <Testimonials />
      <Form ref={contactRef} />
      <Footer />

      <Outlet />
    </div>

  );
}

export default LandingPage;
